import { Customer } from '@app/types';

export const SET_CUSTOMER = 'customer/SET_CUSTOMER';
export const CLEAR_CUSTOMER = 'customer/CLEAR_CUSTOMER';

export const setCustomer = (customer: Partial<Customer> & Dict) => ({
  type: SET_CUSTOMER,
  payload: customer,
});

export const clearCustomer = () => ({
  type: CLEAR_CUSTOMER,
});
